class groups {
  constructor(id, name, instans) {
    this.id = id;
    this.name = name;
    this.instans = instans;
  }
  static fromJson({ grpId, grpNombre, instancias }) {
    return new groups(grpId, grpNombre, instancias);
  }
}
export default groups;
